import { ManualTemplateRequest } from './types';

export const queryKeys = {
  base: ['manualTemplates'] as const,
  manualTemplateByType: (request: ManualTemplateRequest) => [...queryKeys.base, 'manualTemplate', request],
};
